/**
 * Mitigates CSP violations caused by third-party UI code that renders anchors with
 * `href="javascript:..."`.
 *
 * What it does:
 * - Adds a capture-phase click guard that blocks the default navigation.
 *
 * We deliberately do not rewrite the href to `#`. `preventDefault()` leaves Angular's
 * click handlers intact while stopping the CSP-violating default action.
 *
 * Why this exists:
 * Some vendor templates still emit javascript URL hrefs, which violates strict CSP
 * (`script-src` without `unsafe-inline`) and causes browser console errors.
 */
export function installJavascriptHrefCspMitigation(document: Document): void {
  document.addEventListener(
    'click',
    event => {
      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      const anchor = target.closest('a[href]');
      const href = anchor?.getAttribute('href')?.trim().toLowerCase();

      if (href?.startsWith('javascript:')) {
        event.preventDefault();
      }
    },
    true,
  );
}
